import React, { Component } from 'react'
import CollapsibleTile from '../../components/CollapsibleTile';
import { APIData } from '../../constants/APIAdresses';
import GenericTable from '../../components/GenericTable/GenericTable';
import { MUI_COLORS } from '../../constants/MUIConstants';
import { ALERT_SEVERITY } from '../../components/AlertDisplay2';
import { GD_MODE, GD_STATUS_TYPE, GENERIC_DRAWER_TYPE } from '../../components/GenericDrawer';
import { Save } from '@mui/icons-material';
import Close from '@mui/icons-material/Close';

const allergenColumns = [
    { dataKey: 'id', label: 'ID', width: 120 },
    { dataKey: 'uniqueKey', label: 'Eindeutige Bezeichnung', width: 150 },
    { dataKey: 'defaultLabel', label: 'Standardbezeichnung', }
]
export class AllergensTile extends Component {
    constructor(props){
        super(props);
        this.state={
            allergenData: []
        }
    }
    deleteAllergen(index, rowId) {
        // Delete Allergens from API
        fetch(APIData.SHOP + `/allergens/${rowId}/delete`, { credentials: 'include', method: 'DELETE' })
            .then(response => {
                if (response.ok) {
                    let data = [...this.state.allergenData];
                    data.splice(index, 1);
                    this.setState({ allergenData: data });
                } else {
                    console.log("Error while deleting allergen: ", response);
                    this.props.showAlertDisplay("Das Allergen konnte nicht gelöscht werden (" + response.status + ").", ALERT_SEVERITY.ERROR);
                }
            }).catch(e => {
                console.log("Error while deleting allergen: ", e);
                this.props.showAlertDisplay("Das Allergen konnte nicht gelöscht werden.", ALERT_SEVERITY.ERROR);
            })
    }
    updateAllergens(configData,index, id) {
        let body = {
            fields: {

            }
        }
        let filteredFields = configData.fields.filter((field) => { return field.status === GD_STATUS_TYPE.UPDATE });
        filteredFields.forEach((field) => {
            body.fields[field.dbKey] = field.value;
        })
        fetch(APIData.SHOP + `/allergens/${id}/update`, { credentials: 'include', method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(response => {
            this.props.closeDrawer();
            if(response.ok){
                let data = [...this.state.allergenData];
                data[index] = {...data[index], ...body.fields};
                this.setState({allergenData: data});
                this.props.showAlertDisplay("Allergen erfolgreich aktualisiert.", ALERT_SEVERITY.SUCCESS);
            }else{
                this.props.showAlertDisplay("Das Allergen konnte nicht aktualisiert werden (" + response.status + ").", ALERT_SEVERITY.ERROR);
            }
        }).catch(e => {
            console.log("Error while updating allergenData: ", e);
            this.props.showAlertDisplay("Das Allergen konnte nicht aktualisiert werden.", ALERT_SEVERITY.ERROR);
        })

    }
    openAllergenEditDrawer(index, rowId) {
        let baseDrawerConfig = {
            options: [
                {
                    label: "Speichern",
                    icon: <Save />,
                    doRequiredFieldCheck: true,
                    onClick: (configData) => { this.updateAllergens(configData, index, rowId) }
                },{
                    label: "Abbrechen",
                    icon: <Close />,
                    onClick: (configData) => { this.props.closeDrawer() }
                }
            ],
            fields: [
                {
                    label: "ID",
                    disabled: true,
                    type: GENERIC_DRAWER_TYPE.TEXT,
                    value: rowId,
                    dbKey: "id",
                },
                {
                    label: "Eindeutige Bezeichnung",
                    type: GENERIC_DRAWER_TYPE.TEXT,
                    value: this.state.allergenData[index].uniqueKey,
                    dbKey: "uniqueKey",
                    isRequired: true
                },
                {
                    label: "Standardbezeichnung",
                    type: GENERIC_DRAWER_TYPE.TEXT,
                    value: this.state.allergenData[index].defaultLabel,
                    dbKey: "defaultLabel",
                    isRequired: true
                },
            ]
        }
        this.props.openDrawer(baseDrawerConfig, GD_MODE.UPDATE);
    }
    addAllergen(configData) {
        console.log("ADDALLERGEN: ",configData);
        let body = {
            fields: {}
        }
        configData.fields.forEach((field) => {
            body.fields[field.dbKey] = field.value;
        });
        fetch(APIData.SHOP + "/allergens/add", { credentials: 'include', method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(response => {
            if(response.ok) {
                return response.json();
            }else{
                this.props.showAlertDisplay("Das Allergen konnte nicht hinzugefügt werden (" + response.status + ").", ALERT_SEVERITY.ERROR);
                return null;
            }
        })
        .then(result => {
            if(result.id != null){
                let data = [...this.state.allergenData];
                data.push({...body.fields, id: result.id});
                this.setState({allergenData: data});
                this.props.closeDrawer();
            }
        })
        .catch(e => {
            console.log("Error while adding allergen: ", e);
            this.props.showAlertDisplay("Das Allergen konnte nicht hinzugefügt werden.", ALERT_SEVERITY.ERROR);
        })
        
    }
    openNewAllergenDrawer() {
        let baseDrawerConfig = {
            options: [
                {
                    label: "Hinzufügen",
                    icon: <Save />,
                    doRequiredFieldCheck: true,
                    onClick: (configData) => { this.addAllergen(configData) }
                },{
                    label: "Abbrechen",
                    icon: <Close />,
                    onClick: (configData) => { this.props.closeDrawer() }
                }
            ],
            fields: [
                {
                    label: "Eindeutige Bezeichnung",
                    type: GENERIC_DRAWER_TYPE.TEXT,
                    value: "",
                    dbKey: "uniqueKey",
                    isRequired: true
                },
                {
                    label: "Standardbezeichnung",
                    type: GENERIC_DRAWER_TYPE.TEXT,
                    value: "",
                    dbKey: "defaultLabel",
                    isRequired: true
                },
            ]
        }
        this.props.openDrawer(baseDrawerConfig, GD_MODE.NEW);
    }
    render() {
        return (
            <CollapsibleTile
                onCollapseChange={(expanded) => { }}
                title="Allergene"
                icon={<img src={require('../../assets/icons/peanut.png')} width={20} height={20} />}
            >
                <GenericTable
                    config={{ columns: [...allergenColumns] }}
                    apiEndPoint={APIData.SHOP + "/allergens/getPaged"}
                    tableData={this.state.allergenData}
                    setTableData={(data) => { this.setState({ allergenData: data }) }}
                    onEdit={(index, rowId) => { 
                        this.openAllergenEditDrawer(index, rowId);
                        console.log("index: ", index, " rowId: ", rowId) }}
                    onDelete={(index, rowId) => {
                        this.props.openAlertDialog(
                            [
                                {
                                    label: "Ja",
                                    color: MUI_COLORS.ERROR,
                                    onChoice: () => {
                                        this.deleteAllergen(index, rowId);
                                    }
                                },
                                {
                                    label: "Nein",
                                    onChoice: () => {
                                        console.log("Allergen wird nicht gelöscht...");
                                    }
                                }
                            ],
                            "Löschen", `Möchten Sie das Allergen '${this.state.allergenData[index].defaultLabel}' wirklich löschen?`)
                        console.log("index: ", index, " rowId: ", rowId)
                    }}
                    addBtnOnClick={() => { 
                        this.openNewAllergenDrawer();
                     }}
                    addBtnLabel="Nährstoff Hinzufügen"
                />
            </CollapsibleTile>
        )
    }
}

export default AllergensTile